import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Switch,
  FormControlLabel,
  Button,
  MenuItem
} from '@mui/material';
import { CargoDto } from '../../../../services/api/cargosApi';
import { useAreasApi } from '../../../../services/api/areasApi';

interface CargosModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: CargoDto) => Promise<void>;
  title: string;
  initialData?: CargoDto;
  isLoading: boolean;
  isEdit?: boolean;
}

const CargosModal: React.FC<CargosModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  initialData,
  isLoading,
  isEdit = false
}) => {
  const [formData, setFormData] = useState<CargoDto>({
    IdArea: 0,
    Nombre: '',
    Activo: true
  });

  const { getAll: getAllAreas } = useAreasApi();
  const [areas, setAreas] = useState<Array<{ Id: number; Nombre: string }>>([]);

  useEffect(() => {
    const loadAreas = async () => {
      const areasData = await getAllAreas();
      setAreas(areasData.filter(area => area.Activo));
    };
    loadAreas();
  }, []);

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData({ IdArea: 0, Nombre: '', Activo: true });
    }
  }, [initialData, isOpen]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSubmit(formData);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            select
            margin="dense"
            label="Área"
            fullWidth
            required
            value={formData.IdArea}
            onChange={(e) => setFormData({ ...formData, IdArea: Number(e.target.value) })}
            sx={{ mb: 2 }}
          >
            <MenuItem value={0} disabled>Seleccione un área</MenuItem>
            {areas.map((area) => (
              <MenuItem key={area.Id} value={area.Id}>
                {area.Nombre}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            autoFocus
            margin="dense"
            label="Nombre del Cargo"
            fullWidth
            required
            value={formData.Nombre}
            onChange={(e) => setFormData({ ...formData, Nombre: e.target.value })}
            sx={{ mb: 2 }}
          />
          {!isEdit && (
            <FormControlLabel
              control={
                <Switch
                  checked={formData.Activo}
                  onChange={(e) => setFormData({ ...formData, Activo: e.target.checked })}
                />
              }
              label="Activo"
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button type="submit" variant="contained" disabled={isLoading || formData.IdArea === 0}>
            {isLoading ? 'Guardando...' : isEdit ? 'Actualizar' : 'Guardar'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CargosModal;